import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  CircularProgress,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Icon,
} from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material'; // Icons for validity
import { useGetUserTransactionsQuery } from '../apis/TransationApi';

const TransactionsTableNetProfit = ({ userId, isActive }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data, isLoading, isError, error } = useGetUserTransactionsQuery({
    userId,
    isActive,
    page,
    size: rowsPerPage,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen is mobile-sized

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when changing rows per page
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A'; // Handle empty dates
    const date = new Date(dateString);
    return date.toLocaleString(); // Format date to a readable string
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return <Typography color="error">Error: {error.message}</Typography>;
  }

  return (
    <Paper>
      <TableContainer>
        {isMobile ? (
          // Mobile View: Display data vertically
          <Box>
            {data.transactions.map((transaction) => (
              <Box key={transaction.id} sx={{ p: 2, borderBottom: '1px solid #ddd' }}>
                <Typography variant="subtitle1"><strong>Order Number:</strong> {transaction.orderNumber}</Typography>
                <Typography variant="body1"><strong>Order amount :</strong> {transaction.transactionAmount}</Typography>
                <Typography variant="body1"><strong>Net Profit:</strong> {transaction.earnedPlusCapitalAmount}</Typography>
                <Typography variant="body1"><strong>Created:</strong> {formatDate(transaction.createdAt)}</Typography>
                 <Typography variant="body1">
                  <strong>Validity:</strong>
                  {transaction.depositAt ? (
                    <Icon sx={{ color: 'green', ml: 1 }}>
                      <CheckCircle />
                    </Icon>
                  ) : (
                    <Icon sx={{ color: 'red', ml: 1 }}>
                      <Cancel />
                    </Icon>
                  )}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          // PC View: Display data in a table
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Order Number</TableCell>
                <TableCell>Order amount </TableCell>
                <TableCell>profit</TableCell>
                <TableCell>Created</TableCell>
                 <TableCell>Validity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.transactions.map((transaction) => (
                <TableRow key={transaction.id}>
                  <TableCell>{transaction.orderNumber}</TableCell>
                  <TableCell>{transaction.transactionAmount}</TableCell>
                  <TableCell>{transaction.earnedPlusCapitalAmount}</TableCell>
                  <TableCell>{formatDate(transaction.createdAt)}</TableCell>
                   <TableCell>
                    {transaction.depositAt ? (
                      <Icon sx={{ color: 'green' }}>
                        <CheckCircle />
                      </Icon>
                    ) : (
                      <Icon sx={{ color: 'red' }}>
                        <Cancel />
                      </Icon>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data.totalItems}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default TransactionsTableNetProfit;